module.exports = __webpack_public_path__ + "static/media/Rino-logo-111019.a8c1be94.svg";